module.exports = __webpack_public_path__ + "img/backArrow.9daea5fb.svg";